module.exports = __webpack_public_path__ + "img/medical-operations-x.eef3d669.svg";